import { RouterType } from '@online-webinar/router';
import { WebinarPollResults } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/poll-result'].update({
        staticData: { title: { page: 'Insights.Polls.PageHeading', forWebinar: true } },
        component: authGuard(WebinarPollResults, { canBroadcast: true })
    });
};
